import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import BasketStrainer from 'features/processFlowDiagrams/svg/piping/basket-strainer.svg?react'
import Blank from 'features/processFlowDiagrams/svg/piping/blank.svg?react'
import Breather from 'features/processFlowDiagrams/svg/piping/breather.svg?react'
import Cap from 'features/processFlowDiagrams/svg/piping/cap.svg?react'
import ClosedFigure8Blind from 'features/processFlowDiagrams/svg/piping/closed-figure-8-blind.svg?react'
import ConcentricReducer from 'features/processFlowDiagrams/svg/piping/concentric-reducer.svg?react'
import ConeStrainer from 'features/processFlowDiagrams/svg/piping/cone-strainer.svg?react'
import Damper from 'features/processFlowDiagrams/svg/piping/damper.svg?react'
import DesuperHeater from 'features/processFlowDiagrams/svg/piping/desuper-heater.svg?react'
import DetonationArrestor from 'features/processFlowDiagrams/svg/piping/detonation-arrestor.svg?react'
import DiverterValve from 'features/processFlowDiagrams/svg/piping/diverter-valve.svg?react'
import DoubleFlange from 'features/processFlowDiagrams/svg/piping/double-flange.svg?react'
import DuplexStrainer from 'features/processFlowDiagrams/svg/piping/duplex-strainer.svg?react'
import EccentricReducer from 'features/processFlowDiagrams/svg/piping/eccentric-reducer.svg?react'
import ExcessFlowValve from 'features/processFlowDiagrams/svg/piping/excess-flow-valve.svg?react'
import ExhaustHead from 'features/processFlowDiagrams/svg/piping/exhaust-head.svg?react'
import ExpansionJoint from 'features/processFlowDiagrams/svg/piping/expansion-joint.svg?react'
import FlameArrestor from 'features/processFlowDiagrams/svg/piping/flame-arrestor.svg?react'
import Flange from 'features/processFlowDiagrams/svg/piping/flange.svg?react'
import FlangeIn from 'features/processFlowDiagrams/svg/piping/flange-in.svg?react'
import FlexibleHose from 'features/processFlowDiagrams/svg/piping/flexible-hose.svg?react'
import HoseConnection from 'features/processFlowDiagrams/svg/piping/hose-connection.svg?react'
import InLineMixer from 'features/processFlowDiagrams/svg/piping/in-line-mixer.svg?react'
import InLineSilencer from 'features/processFlowDiagrams/svg/piping/in-line-silencer.svg?react'
import OpenFigure8Blind from 'features/processFlowDiagrams/svg/piping/open-figure-8-blind.svg?react'
import OrificeQuickChange from 'features/processFlowDiagrams/svg/piping/orifice-quick-change.svg?react'
import Plug from 'features/processFlowDiagrams/svg/piping/plug.svg?react'
import PulsationDampener from 'features/processFlowDiagrams/svg/piping/pulsation-dampener.svg?react'
import RemovableSpool from 'features/processFlowDiagrams/svg/piping/removable-spool.svg?react'
import RotaryValve from 'features/processFlowDiagrams/svg/piping/rotary-valve.svg?react'
import Spacer from 'features/processFlowDiagrams/svg/piping/spacer.svg?react'
import SteamTrap from 'features/processFlowDiagrams/svg/piping/steam-trap.svg?react'
import TTypeStrainer from 'features/processFlowDiagrams/svg/piping/t-type-strainer.svg?react'
import TemporaryStrainer from 'features/processFlowDiagrams/svg/piping/temporary-strainer.svg?react'
import VentSilencer from 'features/processFlowDiagrams/svg/piping/vent-silencer.svg?react'
import WeldedConnection from 'features/processFlowDiagrams/svg/piping/welded-connection.svg?react'
import YTypeStrainer from 'features/processFlowDiagrams/svg/piping/y-type-strainer.svg?react'
import React from 'react'

export const PID_PIPING_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'basket-strainer',
    name: 'Basket Strainer',
    category: 'piping',
    svgContent: <BasketStrainer />,
    viewBox: '0 0 50 45',
  },
  {
    id: 'blank',
    name: 'Blank',
    category: 'piping',
    svgContent: <Blank />,
    viewBox: '0 0 20 60',
  },
  {
    id: 'breather',
    name: 'Breather',
    category: 'piping',
    svgContent: <Breather />,
    viewBox: '0 0 50 30',
  },
  {
    id: 'cap',
    name: 'Cap',
    category: 'piping',
    svgContent: <Cap />,
    viewBox: '0 0 10 20',
  },
  {
    id: 'closed-figure-8-blind',
    name: 'Closed Figure 8 Blind',
    category: 'piping',
    svgContent: <ClosedFigure8Blind />,
    viewBox: '0 0 20 80',
  },
  {
    id: 'concentric-reducer',
    name: 'Concentric Reducer',
    category: 'piping',
    svgContent: <ConcentricReducer />,
    viewBox: '0 0 20 20',
  },
  {
    id: 'cone-strainer',
    name: 'Cone Strainer',
    category: 'piping',
    svgContent: <ConeStrainer />,
    viewBox: '0 0 30 30',
  },
  {
    id: 'damper',
    name: 'Damper',
    category: 'piping',
    svgContent: <Damper />,
    viewBox: '0 0 50 20',
  },
  {
    id: 'desuper-heater',
    name: 'Desuper Heater',
    category: 'piping',
    svgContent: <DesuperHeater />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'detonation-arrestor',
    name: 'Detonation Arrestor',
    category: 'piping',
    svgContent: <DetonationArrestor />,
    viewBox: '0 0 50 19',
  },
  {
    id: 'diverter-valve',
    name: 'Diverter Valve',
    category: 'piping',
    svgContent: <DiverterValve />,
    viewBox: '0 0 50 34',
  },
  {
    id: 'double-flange',
    name: 'Double Flange',
    category: 'piping',
    svgContent: <DoubleFlange />,
    viewBox: '0 0 5 20',
  },
  {
    id: 'duplex-strainer',
    name: 'Duplex Strainer',
    category: 'piping',
    svgContent: <DuplexStrainer />,
    viewBox: '0 0 50 40',
  },
  {
    id: 'eccentric-reducer',
    name: 'Eccentric Reducer',
    category: 'piping',
    svgContent: <EccentricReducer />,
    viewBox: '0 0 20 15',
  },
  {
    id: 'excess-flow-valve',
    name: 'Excess Flow Valve',
    category: 'piping',
    svgContent: <ExcessFlowValve />,
    viewBox: '0 0 50 24',
  },
  {
    id: 'exhaust-head',
    name: 'Exhaust Head',
    category: 'piping',
    svgContent: <ExhaustHead />,
    viewBox: '0 0 50 40',
  },
  {
    id: 'expansion-joint',
    name: 'Expansion Joint',
    category: 'piping',
    svgContent: <ExpansionJoint />,
    viewBox: '0 0 50 20',
  },
  {
    id: 'flame-arrestor',
    name: 'Flame Arrestor',
    category: 'piping',
    svgContent: <FlameArrestor />,
    viewBox: '0 0 50 19',
  },
  {
    id: 'flange',
    name: 'Flange',
    category: 'piping',
    svgContent: <Flange />,
    viewBox: '0 0 5 20',
  },
  {
    id: 'flange-in',
    name: 'Flange In',
    category: 'piping',
    svgContent: <FlangeIn />,
    viewBox: '0 0 8 20',
  },
  {
    id: 'flexible-hose',
    name: 'Flexible Hose',
    category: 'piping',
    svgContent: <FlexibleHose />,
    viewBox: '0 0 50 23',
  },
  {
    id: 'hose-connection',
    name: 'Hose Connection',
    category: 'piping',
    svgContent: <HoseConnection />,
    viewBox: '0 0 20 20',
  },
  {
    id: 'in-line-mixer',
    name: 'In-Line Mixer',
    category: 'piping',
    svgContent: <InLineMixer />,
    viewBox: '0 0 50 10',
  },
  {
    id: 'in-line-silencer',
    name: 'In-Line Silencer',
    category: 'piping',
    svgContent: <InLineSilencer />,
    viewBox: '0 0 50 19',
  },
  {
    id: 'open-figure-8-blind',
    name: 'Open Figure 8 Blind',
    category: 'piping',
    svgContent: <OpenFigure8Blind />,
    viewBox: '0 0 20 80',
  },
  {
    id: 'orifice-quick-change',
    name: 'Orifice (Quick Change)',
    category: 'piping',
    svgContent: <OrificeQuickChange />,
    viewBox: '0 0 10 50',
  },
  {
    id: 'plug',
    name: 'Plug',
    category: 'piping',
    svgContent: <Plug />,
    viewBox: '0 0 10 10',
  },
  {
    id: 'pulsation-dampener',
    name: 'Pulsation Dampener',
    category: 'piping',
    svgContent: <PulsationDampener />,
    viewBox: '0 0 50 150',
  },
  {
    id: 'removable-spool',
    name: 'Removable Spool',
    category: 'piping',
    svgContent: <RemovableSpool />,
    viewBox: '0 0 50 30',
  },
  {
    id: 'rotary-valve',
    name: 'Rotary Valve',
    category: 'piping',
    svgContent: <RotaryValve />,
    viewBox: '0 0 50 20',
  },
  {
    id: 'spacer',
    name: 'Spacer',
    category: 'piping',
    svgContent: <Spacer />,
    viewBox: '0 0 20 60',
  },
  {
    id: 'steam-trap',
    name: 'Steam Trap',
    category: 'piping',
    svgContent: <SteamTrap />,
    viewBox: '0 0 50 50',
  },
  {
    id: 't-type-strainer',
    name: 'T-Type Strainer',
    category: 'piping',
    svgContent: <TTypeStrainer />,
    viewBox: '0 0 20 34',
  },
  {
    id: 'temporary-strainer',
    name: 'Temporary Strainer',
    category: 'piping',
    svgContent: <TemporaryStrainer />,
    viewBox: '0 0 30 30',
  },
  {
    id: 'vent-silencer',
    name: 'Vent Silencer',
    category: 'piping',
    svgContent: <VentSilencer />,
    viewBox: '0 0 19 80',
  },
  {
    id: 'welded-connection',
    name: 'Welded Connection',
    category: 'piping',
    svgContent: <WeldedConnection />,
    viewBox: '0 0 50 20',
  },
  {
    id: 'y-type-strainer',
    name: 'Y-Type Strainer',
    category: 'piping',
    svgContent: <YTypeStrainer />,
    viewBox: '0 0 50 34',
  },
]
